const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

export function formatBytes(value: number | null | undefined): string {
    if (value == null || !isFinite(value) || value <= 0) return '0 B';
    const i = Math.min(Math.floor(Math.log10(value) / 3), BYTE_UNITS.length - 1);
    const scaled = value / Math.pow(1000, i);
    return `${scaled >= 10 ? scaled.toFixed(0) : scaled.toFixed(1)} ${BYTE_UNITS[i]}`;
}
